/**
 * Portal flow error codes.
 */
export enum PortalErrorCode {
  CONFIG_LOAD_FAILED = 'error.portal.config_load.failed',
  SUB_DATA_LOAD_FAILED = 'error.portal.sub_data_load.failed',
  SUBSCRIPTION_OVERRIDE_BILLING_PROFILE_FAILED = 'error.portal.subscription_override_billing_profile.failed',
  CHANGE_ORDER_FAILED = 'error.portal.change_order.failed',
  INVOICE_LIST_FAILED = 'error.portal.invoice_list.failed',
  INVOICE_DOWNLOAD_FAILED = 'error.portal.invoice_download.failed',
  SUBSCRIPTION_DETAILS_FAILED = 'error.portal.subscription_details.failed',
  SUBSCRIPTION_NOT_FOUND = 'error.portal.subscription_not_found',
  PORTAL_UPDATE_FAILED = 'error.portal.portal_update.failed',
  PAYMENT_SOURCE_CREATE_FAILED = 'error.portal.payment_source_create.failed',
  PAYMENT_SOURCE_UPDATE_FAILED = 'error.portal.payment_source_update.failed',
  PAYMENT_SOURCE_REMOVE_FAILED = 'error.portal.payment_source_remove.failed',
  PAYMENT_SOURCE_ASSIGN_ROLE_FAILED = 'error.portal.payment_source_assign_role.failed',
  TRIGGER_MAIL_FAILED = 'error.portal.trigger_mail.failed',
  BRIGHTBACK_FAILED = 'error.portal.brightback.failed',
  EXTEND_SUBSCRIPTION_FAILED = 'error.portal.extend_subscription.failed',
}
